import { appConfig } from '~/appConfig';
import AbstractLocalRepository from '~base/AbstractLocalRepository';

export default class LangLocalRepository extends AbstractLocalRepository {
  tableName(): string {
    return appConfig.langStorageKey;
  }
}
